<template>
    <div id="app" v-on:scroll="scrollFunction">
        <div id="buttonadd" ref="buttonadd">ADD</div>
        <Header/>
        <component v-bind:is="component"></component>
    </div>
</template>

<style lang="scss">
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 0px;
        height: 100vh;
        overflow: hidden;
        overflow-y: auto;
    }
.mainInstall{
    position: fixed;
    z-index: 98087987;
    top:0px;
    width: 100%;
    background-color: #2c3e50;
    color:#ffffff;
    padding:20px 0px;
}
#buttonadd{
    position: fixed;
    width:100%;
    top:0px;
    padding:20px 0px;
    background-color: #11caeb;
    color: #ffffff;
        display: none;
}



</style>

<script>
    import Header from './components/Header.vue'
    import Start from './components/Start.vue'

    let scrollPos = 0;


    export default {
        name: 'app',
        components: {
            Header,
            Start,
        },
        data (){
            return {
                component:"Start",
                installBtn: "none",
                installer: undefined,
                isActive: false
            }
        },
        mounted(){
            let deferredPrompt;
            let btnAdd = this.$refs.buttonadd;
            window.console.log('mounted');
            window.addEventListener('beforeinstallprompt', function(e) {
                e.preventDefault();
                btnAdd.style.display = 'block';
                deferredPrompt = e;
                window.console.log(deferredPrompt);
            });


            btnAdd.addEventListener('click', () => {
                btnAdd.style.display = 'none';
                deferredPrompt.prompt();
                deferredPrompt.userChoice
                    .then((choiceResult) => {
                        if (choiceResult.outcome === 'accepted') {
                            window.console.log('User accepted the A2HS prompt');
                        } else {
                            window.console.log('User dismissed the A2HS prompt');
                        }
                        deferredPrompt = null;
                    });
            });
        },
        methods: {
            scrollFunction () {
                const container = document.querySelector('#app')

                if(scrollPos < container.scrollTop){
                    this.isActive = true;
                }else{
                    this.isActive = false;
                }
                scrollPos = container.scrollTop;
            }
        }
    }
</script>

